import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { NAV } from "@/constants/testIds";

export default function NotificationsBell() {
  const [notifications, setNotifications] = useState([]);
  const { t } = useI18n();

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setNotifications(data);
    } catch (e) {
      /* silent */
    }
  };

  useEffect(() => {
    load();
    const interval = setInterval(load, 15000);
    return () => clearInterval(interval);
  }, []);

  const unreadCount = notifications.filter((n) => !n.read).length;

  const markAllRead = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative rounded-full" data-testid={NAV.notificationsBell}>
          <Bell className="h-5 w-5" strokeWidth={1.5} />
          {unreadCount > 0 && (
            <Badge className="absolute -right-1 -top-1 h-4 min-w-4 rounded-full bg-primary px-1 text-[10px] text-primary-foreground">
              {unreadCount}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between border-b border-border p-3">
          <span className="font-heading text-sm font-semibold">{t("dashboard.notifications")}</span>
          {unreadCount > 0 && (
            <button onClick={markAllRead} className="text-xs text-primary hover:underline">
              {t("dashboard.markAllRead")}
            </button>
          )}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {notifications.length === 0 && (
            <p className="p-4 text-center text-sm text-muted-foreground">{t("dashboard.noNotifications")}</p>
          )}
          {notifications.map((n) => (
            <div key={n.notif_id} className={`border-b border-border p-3 text-sm last:border-0 ${!n.read ? "bg-accent/5" : ""}`}>
              <p className="font-medium">{n.title}</p>
              <p className="mt-0.5 text-xs text-muted-foreground">{n.message}</p>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
